import styled from 'styled-components';
import { Box, color, fontSize, fontWeight } from '@landr/maestro';

export const Wrapper = styled(Box)<{ variant: 'compact' | 'default' }>`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Name = styled(Box)<{ size?: 'sm' | 'md' | 'lg' }>`
    color: ${color('text.base')};
    font-size: ${({ size }) => {
        return size === 'lg' ? fontSize('md') : fontSize('sm');
    }};
    font-weight: ${fontWeight('bold')};
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const Styled = {
    Name,
    Wrapper,
};
